import { render } from "./PageNotFound.vue?vue&type=template&id=4ae6c971"
const script = {}

import "./PageNotFound.vue?vue&type=style&index=0&id=4ae6c971&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__